import type { AttorneySummaryGroup } from "@/lib/data/requests/reports/reports-attorney-summary";
import {
  count,
  money,
  moneyWithCents,
  type ReportColumn,
} from "../shared/ReportTable";

const numberValue = (value: string | null) =>
  value === null ? null : Number(value);

export const attorneyColumns: ReportColumn<AttorneySummaryGroup>[] = [
  { label: "Assigned user", value: (r) => r.label, render: (r) => r.label },
  {
    label: "Accepted amount",
    numeric: true,
    value: (r) => numberValue(r.acceptedAmount),
    render: (r) => money(r.acceptedAmount),
  },
  {
    label: "Demands sent",
    numeric: true,
    value: (r) => r.demandsSent,
    render: (r) => count(r.demandsSent),
  },
  {
    label: "Accepted records",
    numeric: true,
    value: (r) => r.acceptedRecords,
    render: (r) => count(r.acceptedRecords),
  },
  {
    label: "Trust deposits",
    numeric: true,
    value: (r) => numberValue(r.trustDeposits),
    render: (r) => money(r.trustDeposits),
  },
  {
    label: "Expected fees",
    numeric: true,
    value: (r) => numberValue(r.expectedFees),
    render: (r) => moneyWithCents(r.expectedFees),
  },
  {
    label: "Avg expected fees / matter (litigation)",
    numeric: true,
    value: (r) => numberValue(r.averageLitigationExpectedFees),
    render: (r) => moneyWithCents(r.averageLitigationExpectedFees),
  },
  {
    label: "Avg expected fees / matter (no litigation)",
    numeric: true,
    value: (r) => numberValue(r.averageNonLitigationExpectedFees),
    render: (r) => moneyWithCents(r.averageNonLitigationExpectedFees),
  },
  {
    label: "Avg days created to closed (linked deposit)",
    numeric: true,
    value: (r) => numberValue(r.averageDaysToCloseWithDeposit),
    render: (r) => count(r.averageDaysToCloseWithDeposit),
  },
  {
    label: "Avg days created to closed (no linked deposit)",
    numeric: true,
    value: (r) => numberValue(r.averageDaysToCloseWithoutDeposit),
    render: (r) => count(r.averageDaysToCloseWithoutDeposit),
  },
  {
    label: "Closed with linked deposit",
    numeric: true,
    value: (r) => r.closedWithLinkedDeposit,
    render: (r) => count(r.closedWithLinkedDeposit),
  },
  {
    label: "Closed without linked deposit",
    numeric: true,
    value: (r) => r.closedWithoutLinkedDeposit,
    render: (r) => count(r.closedWithoutLinkedDeposit),
  },
  {
    label: "Trust withdrawals",
    numeric: true,
    value: (r) => numberValue(r.trustWithdrawals),
    render: (r) => money(r.trustWithdrawals),
  },
  {
    label: "Open matters",
    numeric: true,
    value: (r) => r.openMatters,
    render: (r) => count(r.openMatters),
  },
];
